import styled, { css } from 'styled-components'
import {
  Noto_body3_m12,
  Noto_body3_r12,
  Noto_subheading_b18,
} from 'src/styles/fonts/NotoSansKrFonts'
import { Container } from 'src/components/common/Container'
import { Typography } from 'src/components/common/Typography'
import { CustomSwiper } from 'src/components/common/CustomSwiper'
import usePageNav from 'src/hooks/usePageNav.hook'
import { PopularCouponListSpace } from 'src/types/api'
import LazyImage from 'src/components/common/LazyImage'
import { Roboto_num2_b16 } from 'src/styles/fonts/RobotoFonts'
import { getBrandAndCouponName } from 'src/utils'
import { ellip } from 'src/styles/mixin'

const SearchPopularCoupon = ({
  PopularCoupon,
}: {
  PopularCoupon?: PopularCouponListSpace.PopularCouponItemType[]
}) => {
  const { alwaysCouponDetailPageNav } = usePageNav()
  return (
    <Container $option="flex_column" $style={S.SearchPopularCoupon.Container} $row_gap="12px">
      <S.SearchPopularCoupon.PrimaryText $fontStyle={Noto_subheading_b18}>
        지금 인기있는 상품
      </S.SearchPopularCoupon.PrimaryText>
      <CustomSwiper.Wrap type="default" $wrapstyle={S.CouponCardSwiperStyle} gap={10}>
        {PopularCoupon?.map((ele, index: number) => {
          const { CouponImage, CouponNumber, CouponIdx, CouponName, SalePrice, DiscountRate } = ele

          return (
            <CustomSwiper.Item key={index}>
              <S.CouponCard.Container
                $option="flex_column"
                $row_gap="6px"
                onClick={() => alwaysCouponDetailPageNav(CouponNumber, CouponIdx)}
              >
                <LazyImage src={CouponImage} alt={'쿠폰이미지'} style={S.CouponCard.Image} />
                <S.CouponCard.TextContainer $option="flex_column">
                  <S.CouponCard.DiscountRate $fontStyle={Roboto_num2_b16} $color="var(--brand-50)">
                    {Math.floor((DiscountRate as number) * 10) / 10}%
                  </S.CouponCard.DiscountRate>
                  <S.CouponCard.SalePrice $fontStyle={Roboto_num2_b16} $color="var(--black-90)">
                    {SalePrice?.toLocaleString()}원
                  </S.CouponCard.SalePrice>
                  <S.CouponCard.CouponBrand $fontStyle={Noto_body3_m12} $color="var(--black-90)">
                    {getBrandAndCouponName(CouponName).brandName}
                  </S.CouponCard.CouponBrand>
                  <S.CouponCard.CouponName $fontStyle={Noto_body3_r12} $color="var(--black-90)">
                    {getBrandAndCouponName(CouponName).couponName}
                  </S.CouponCard.CouponName>
                </S.CouponCard.TextContainer>
              </S.CouponCard.Container>
            </CustomSwiper.Item>
          )
        })}
      </CustomSwiper.Wrap>
    </Container>
  )
}

const S = {
  SearchPopularCoupon: {
    Container: css`
      margin: 30px auto 50px auto;
    `,
    PrimaryText: styled(Typography)`
      padding: 0 20px;
    `,
  },
  CouponCard: {
    Container: styled(Container)`
      cursor: pointer;
      width: 100px;
    `,
    Image: css`
      border-radius: 10px;
      border: 1px solid rgba(0, 0, 0, 0.08);
      width: 100px;
      height: 100px;
      &:hover {
        transform: scale(1.05);
      }
    `,
    TextContainer: styled(Container)``,
    DiscountRate: styled(Typography)``,
    SalePrice: styled(Typography)`
      margin-bottom: 4px;
    `,
    CouponBrand: styled(Typography)``,
    CouponName: styled(Typography)`
      ${ellip('line2')};
    `,
  },
  CouponCardSwiperStyle: css`
    display: flex;
    flex-direction: row;
    gap: 10px;
    padding: 0 20px;
    width: 100%;
  `,
}

export default SearchPopularCoupon
